import { get, writable } from 'svelte/store';
import { CustomFieldSchemaService } from '../../services/custom-field-schema.service';
export const loading = writable(false);
export const editing = writable(false);
export const selectedEntity = writable(0);
export const selectedFieldType = writable(null);
export const selectedTable = writable(0);
export const records = writable([]);
export const record = writable(null);
let initialized = false;
export async function init() {
    if (!initialized) {
        initialized = true;
        editing.set(false);
        selectedEntity.set(0);
        selectedFieldType.set(null);
        selectedTable.set(0);
        records.set([]);
        record.set(null);
    }
}
export async function loadEntityValues(entityId) {
    let data = await CustomFieldSchemaService.GetCustomFieldSchemasByEntityId(entityId).toPromise();
    records.set(data.payload);
}
export async function reloadEntityValues() {
    let entityId = get(selectedEntity);
    loadEntityValues(entityId);
}
export function onCreate() {
    let item = {
        oid: 0,
        fieldName: '',
        fieldLabel: '',
        entityId: 0,
        fieldTypeId: 0,
        defaultValue: '',
        description: '',
        listable: 0,
        visible: 1,
        editable: 1,
        listDisplayOrder: 0,
        detailDisplayRow: 0,
        detailDisplayCol: 0,
        listSchemaId: null,
        regionId: 0
    };
    selectedFieldType.set(null);
    record.set(item);
    editing.set(true);
}
export async function onEdit(item) {
    record.set(Object.assign({}, item.customFieldSchema));
    selectedFieldType.set(item.customFieldType);
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    _record.entityId = get(selectedEntity);
    await CustomFieldSchemaService.saveCustomFieldSchema(_record).toPromise();
    await reloadEntityValues();
}
export async function onDelete(item) {
    await CustomFieldSchemaService.deleteCustomFieldSchema(item.oid).toPromise();
    await reloadEntityValues();
}
